import { z } from "zod";

export enum DictionarySupplierSchemaEnum {
	DictionarySupplier = "DictionarySupplier"
};

export const DictionarySupplierSchema = z.object({
	"@id": z.string(), // "/api/dictionary_suppliers/1"
	"@type": z.string(), // "DictionarySupplier"
	id: z.number(), // 1
	libelle: z.string(), // "Supplier 1"
	hb_supplier_id: z.string(), // "1"
	hb_supplier_libelle: z.string(), // "Supplier 1"
}).describe(DictionarySupplierSchemaEnum.DictionarySupplier);

export type DictionarySupplier = z.infer<typeof DictionarySupplierSchema>;
